module.exports = __webpack_public_path__ + "img/restaurant_signaturemenu_image22.932daa69.jpg";